<fieldset class="grid" aria-label="Einstellungen zu LFPR Kosten" data-test-id="aufgabe-versand-root">
	<div class="row">
		<div class="column taetigkeit">
			<mat-radio-group aria-label="Bitte Option wählen" class="column" [formControl]="bodyControls.taetigkeit">
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="kostenTaetigkeit.GEZAHLT"
					data-test-id="gezahlt-radio-button">
					gezahlt
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="kostenTaetigkeit.ERFORDERN"
					data-test-id="erfordern-radio-button">
					gemäß KR erfordern von
				</mat-radio-button>
				@if (bodyControls.taetigkeit.value === kostenTaetigkeit.ERFORDERN) {
					<div class="column">
						<mat-radio-group
							aria-label="Bitte Kostenträger wählen"
							class="column"
							[formControl]="bodyControls.traeger">
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="traeger.NOTAR"
								data-test-id="notar-radio-button">
								Notar
							</mat-radio-button>
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="traeger.EIGENTUEMER"
								data-test-id="eigentuemer-radio-button">
								Eigentümer
							</mat-radio-button>
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="traeger.BERECHTIGTE"
								data-test-id="berechtigte-radio-button">
								Berechtigte II/
							</mat-radio-button>
							@if (bodyControls.traeger.value === traeger.BERECHTIGTE) {
								<schir-int-client-one-value-editor
									type="text"
									label="Nr. in Abt. II"
									[fieldControl]="bodyControls.berechtigteNr"
									class="nr"
									data-test-id="mitteilung-berechtigte-input-nr" />
							}
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="traeger.RECHTSANWALT"
								data-test-id="rechtsanwalt-radio-button">
								Rechtsanwalt
							</mat-radio-button>
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="traeger.SONSTIGE"
								data-test-id="sonstige-radio-button">
								Sonstige
							</mat-radio-button>
						</mat-radio-group>
					</div>
				}
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="kostenTaetigkeit.SOLL"
					data-test-id="soll-radio-button">
					gemäß anliegender KR zum Soll
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="kostenTaetigkeit.FREI"
					data-test-id="gebuehrenfrei-radio-button">
					gebührenfrei gemäß
				</mat-radio-button>
				@if (bodyControls.taetigkeit.value === kostenTaetigkeit.FREI) {
					<div class="column">
						<mat-radio-group
							aria-label="Bitte Begründung wählen"
							class="column"
							[formControl]="bodyControls.grund">
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="grund.PARAGRAPH102"
								data-test-id="paragraph-radio-button">
								§ 102 LuftFZRG
							</mat-radio-button>
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="grund.GNOTKG"
								data-test-id="gnotkg-radio-button">
								GNotKG
							</mat-radio-button>
							<mat-radio-button
								color="primary"
								class="focus-inwards-dark"
								[value]="grund.GES"
								data-test-id="ges-radio-button">
								Ges. v. 28.02.1959
							</mat-radio-button>
						</mat-radio-group>
					</div>
				}
			</mat-radio-group>
		</div>
	</div>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.LFPR_KOSTEN" />
</fieldset>
